export default {
  getProvinceDiscount (provinceDiscounts, provinceId, workHour) {
    workHour = parseFloat(workHour).toFixed(1)
    provinceId = Number(provinceId)
    let discount = null
    for (let key in provinceDiscounts) {
      const provinceDiscount = provinceDiscounts[key]
      // console.log('data type', typeof provinceDiscount.province_id + ' ' + typeof provinceDiscount.work_hour + ' ' + typeof provinceId + ' ' + typeof workHour + ' ' + provinceDiscounts.length)
      if (provinceDiscount.province_id === provinceId && provinceDiscount.work_hour === workHour) {
        discount = provinceDiscount.discount
        break
      }
    }
    return discount
  }
}



// WEBPACK FOOTER //
// ./src/helpers/provinceHelpers.js